import { Injectable } from '@angular/core';
import { EntryNotFoundException } from '@web/common';
import { SelectItem } from '@web/shared/ui';
import { isNil } from '@web/utils';
import { Observable, of } from 'rxjs';
import { AdminBoxQuantityHistoryReasonType } from '../enums/admin-box-quantity-history-reason-type';

@Injectable({
  providedIn: 'root',
})
export class AdminBoxQuantityHistoryReasonTypeProviderService {
  /* prettier-ignore */
  private readonly entries = new Map<AdminBoxQuantityHistoryReasonType, string>([
    [AdminBoxQuantityHistoryReasonType.NewProduct, 'Dodanie produktu, początkowy stan'],
    [AdminBoxQuantityHistoryReasonType.ByNewOrder, 'Nowe zamówienie'],
    [AdminBoxQuantityHistoryReasonType.ByAddToOrderShipment, 'Dodanie do przesyłki'],
    [AdminBoxQuantityHistoryReasonType.ByRemoveFromOrderShipment, 'Usunięcie z przesyłki'],
    [AdminBoxQuantityHistoryReasonType.ByCancelOrder, 'Anulowanie zamówienia'],
    [AdminBoxQuantityHistoryReasonType.ByRefundOrder, 'Zwrot zamówienia'],
    [AdminBoxQuantityHistoryReasonType.Manual, 'Zmiana ręczna'],
  ]);

  public labelFor(type: AdminBoxQuantityHistoryReasonType): Observable<string> {
    const entry = this.entries.get(type);

    if (isNil(entry)) {
      throw new EntryNotFoundException(`The entry for "${type}" not found.`);
    }

    return of(entry);
  }

  public selectItems(): Observable<
    SelectItem<AdminBoxQuantityHistoryReasonType>[]
  > {
    return of(
      Array.from(this.entries.entries()).map(
        ([type, label]) => new SelectItem(label, type),
      ),
    );
  }
}
